export default "__VITE_ASSET__DFdJokLX__"